
<template>
  <v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
    <v-dialog v-model="permitted_dialog" max-width="400px">
      <v-card>
        <v-card-text>
          <div class="text-center">
            <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
            <p>{{message}}</p>
            <v-progress-circular
              :size="70"
              :width="2"
              :value="100"
              color="error"
              class="mb-4 mr-4"
            >
              <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
            </v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
  <v-container v-else v-show="permitted != null" class="pt-0" fluid>
    <v-snackbar
      :value="showMessage()"
      multi-line
      color="#686868"
      top
      
    >
      {{message}}
    </v-snackbar>
    <v-card flat >
    <v-toolbar dense flat color="#2A353D">
      <v-toolbar-title class="white--text subtitle-1 font-weight-normal">{{heading}}</v-toolbar-title>
      <v-spacer/>
      <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
      <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>

      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        bottom
        color="#81DBF6"
      ></v-progress-linear>
    </v-toolbar>
    </v-card>

    <v-alert
      class="my-2"
      dense text
      color="#2A353D"
    >
      <v-row align="center" class="mx-2">
        <v-col class="py-0">
          <v-select
            filled rounded background-color="white" dense
            hide-details
            v-model="parameters.AccountID"
            :items="allClientAccounts.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            class="mx-1"
            @change="getStatement()"
            :item-text="item => item.tblclient.Forename + ` ` + item.tblclient.MajorName +` - ` + item.AccountNumber"
            item-value="AccountID"
            placeholder="----"
            label="Account"
          ></v-select>
        </v-col>
        <v-col class="py-0">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="parameters.start_date"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="parameters.start_date"
                class="mx-1"
                label="Start Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                hide-details
                dense filled rounded background-color="white" color="#2A353D"
                :rules="TextFieldRules"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker @change="getStatement()" color="#2A353D" v-model="parameters.start_date" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
            <v-btn outlined small color="#2A353D" @click="$refs.menu.save(parameters.start_date)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="py-0">
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            :return-value.sync="parameters.end_date"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="parameters.end_date"
                class="mx-1"
                label="End Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                hide-details
                dense filled rounded background-color="white" color="#2A353D"
                :rules="TextFieldRules"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker @change="getStatement()" color="#2A353D" v-model="parameters.end_date" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn outlined small color="#2A353D" @click="menu2 = false">Cancel</v-btn>
            <v-btn outlined small color="#2A353D" @click="$refs.menu2.save(parameters.end_date)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-alert>

    <v-data-table
      :fixed-header="true"
      :headers="headers"
      :items="Statement"
      :search="search"
      :height="520"
      hide-default-footer
      disable-pagination
      @current-items="getFiltered"
      class="elevation-12 mt-2"
    >

      <template v-slot:top>
        <v-container row>
          <v-text-field
            class="ml-3"
            hide-details
            outlined
            placeholder="search..."
            v-model="search"
            append-icon="mdi-magnify"
            dense
          ></v-text-field>

          <v-spacer/>

          <v-menu open-on-hover offset-y>
            <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" outlined small color="#2A353D" class="ml-2">
              EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
            </v-btn>
            </template>
            <v-list dense>
            <v-list-item class="ma-0 pa-0">
              <v-btn @click="generatePDF(false)" text small color="#2A353D">
                <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
              </v-btn>
            </v-list-item>
            <v-list-item class="ma-0 pa-0">
              <v-btn text small color="#2A353D">
                <download-excel
                  :data   = "CurrentCustodians"
                  type    = "xls"
                  name    = "Financial Account Statement.xls">
    
                  <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
                </download-excel>
              </v-btn>
            </v-list-item>
            <v-list-item class="ma-0 pa-0">
              <v-btn text small color="#2A353D">
                <download-excel
                  :data   = "CurrentCustodians"
                  type    = "csv"
                  name    = "Financial Account Statement.csv">
    
                  <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
                </download-excel>
              </v-btn>
            </v-list-item>
            </v-list>
          </v-menu>
          <v-btn @click="generatePDF(true)" outlined small color="#2A353D" class="ml-2" v-on="on">
            PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
          </v-btn>
        </v-container>
      </template>

      <template v-slot:item.Balance="{ item }">
        {{item.Balance.toLocaleString()}}
      </template> 

    </v-data-table>
  </v-container>
</template>

<script>
import reportsService from '../services/reports.service';
import UserService from '../services/user.service';
import {mapGetters} from "vuex";
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  data () {
    return {
      parameters: {},
      Statement: [],
      Contacts: [],
      search: '',
      message: '',
      menu: false,
      loading: false,
      heading: "Client Account Statement",
      menu2: false,
      permitted: null,
      permitted_dialog: true,
      headers: [
        { text: 'Value Date', value: 'ValueDate', sortable: false},
        { text: 'Description', value: 'Description', sortable: false },
        { text: 'Debit', value: 'Debit', sortable: true},
        { text: 'Credit', value: 'Credit', sortable: true},
        { text: 'Balance', value: 'Balance', sortable: true},
      ],
    }
  },

  computed: {
    ...mapGetters([
      "currentImage",
      "allClientAccounts",
      "identity",
      "allCountries",
      "allCities"
    ]),

    currentUser() {
      return this.$store.state.auth.user;
    },
  },

  methods: {
    getStatement() {
      if(this.parameters.start_date != null && this.parameters.end_date != null && this.parameters.AccountID != null){
        this.loading = true;
        reportsService.getFinancialAccountStatement(this.parameters)
        .then(response => {
          this.Statement = response.data.statement;
          // this.Statement.push({Credit: 'TOTAL:', Balance: this.Statement.map(i => Number(i.Balance)).reduce((a, b) => a + b, 0)})
          this.Contacts = response.data.contacts[0];
          this.loading = false
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false
        })
      }
    },
    generatePDF(IsPrint) {
      const columns = [
        { title: 'Value Date', dataKey: 'ValueDate'},
        { title: 'Description', dataKey: 'Description'},
        { title: 'Debit', dataKey: 'Debit'},
        { title: 'Credit', dataKey: 'Credit'},
        { title: 'Balance', dataKey: 'Balance'}
      ];

      // const totals = [
      //   { title: 'Total',  dataKey: 'DealNumber'},
      //   { title: 'Value Date', dataKey: 'ValueDate'}
      // ];

      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          var imgData = 'data:image/png;base64,'+ this.currentImage[0].data;

          doc.addImage(imgData, 'PNG', 0.5, 0.28, 1.3, 0.7);
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text(this.identity[0].OrgName, 6.0, 0.5);
          doc.setFontSize(8).text(this.identity[0].Phadd1, 6.0, 0.7);
          doc.setFontSize(8).text(this.allCities.filter(a => a.CityID == this.identity[0].PhCity).map(a => a.City)[0], 6.0, 0.9);
          doc.setFontSize(8).text(this.allCountries.filter(a => a.CountryId == this.identity[0].PhCountry).map(a => a.CountryName)[0], 6.0, 1.1);
          doc.setFontSize(8).text('email: ' + this.identity[0].OrgMail, 6.0, 1.3);
          doc.setFontSize(8).text('cell: ' + this.identity[0].OrgNumber, 6.0, 1.5);
          doc.setFontSize(10).text(this.heading, 0.5, 1.2);
          doc.setFontSize(8).text(this.Contacts.ClientName == null? '----------' : this.Contacts.ClientName, 0.5, 1.6);
          doc.setFontSize(8).text(this.Contacts.Postal_Address_1 == null? '----------' : this.Contacts.Postal_Address_1, 0.5, 1.8);
          doc.setFontSize(8).text(this.Contacts.Postal_Address_2 == null? '----------' : this.Contacts.Postal_Address_2, 0.5, 2.0);
          doc.setFontSize(8).text(this.Contacts.Postal_Address_3 == null? '----------' : this.Contacts.Postal_Address_3, 0.5, 2.2);
          doc.setFontSize(8).text(this.Contacts.Postal_City == null? '----------' : this.Contacts.Postal_City, 0.5, 2.4);
          doc.setFontSize(8).text(this.Contacts.NametoContact == null? '----------' : this.Contacts.NametoContact, 0.5, 2.6);
          doc.setFontSize(8).text(this.Contacts.AccNumber == null? '----------' : this.Contacts.AccNumber, 0.5, 2.8);
          // doc.setFontSize(8).text(this.Contacts.Currency == null? '----------' : this.Contacts.Currency, 0.5, 3.0);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 3.2, 8.0, 3.2);
          doc.setLineWidth(0.01).line(0.5, 3.4, 8.0, 3.4);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        columns,
        body: this.Statement,
        margin: { left: 0.5, top: 3.2 },
        styles: {overflow: 'linebreak',
                fontSize: 6},
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('Financial Account Statement.pdf')
      }
    },
    getFiltered(current){
      this.CurrentCustodians = current;
    },
    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },
  },

  mounted () {
    UserService.isReports().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }
}
</script>

<style scoped>
.v-btn {
  outline: none
}
</style>